// Loan purpose options + cross-sell alternative options for the partner submission wizard

export const LOAN_PURPOSES = [
  { key: 'debt_consolidation', label: 'Debt Consolidation' },
  { key: 'renovation', label: 'Home Renovation' },
  { key: 'reduce_interest', label: 'Reduce Interest Rate / Refinance' },
  { key: 'investment', label: 'Investment' },
  { key: 'education', label: 'Education' },
  { key: 'medical', label: 'Medical Expenses' },
  { key: 'wedding', label: 'Wedding' },
  { key: 'vehicle', label: 'Vehicle Purchase' },
  { key: 'business_capital', label: 'Business Capital' },
  { key: 'travel', label: 'Travel / Holiday' },
  { key: 'emergency', label: 'Emergency Fund' },
  { key: 'property_purchase', label: 'Property Purchase' },
  { key: 'property_downpayment', label: 'Property Down Payment' },
  { key: 'cash_flow', label: 'Cash Flow Improvement' },
  { key: 'other', label: 'Other' },
];

export const CROSS_SELL_OPTIONS = [
  { key: 'credit_card', label: 'Credit Card' },
  { key: 'money_lender', label: 'Money Lender' },
  { key: 'financial_advisory', label: 'Financial Advisory' },
  { key: 'investment_product', label: 'Investment Product' },
  { key: 'insurance', label: 'Insurance / Takaful' },
];

export const EMPLOYMENT_TYPES = [
  { key: 'salaried', label: 'Salaried (Private)', group: 'salaried' },
  { key: 'government', label: 'Government', group: 'salaried' },
  { key: 'glc', label: 'GLC', group: 'salaried' },
  { key: 'army', label: 'Army / Police', group: 'salaried' },
  { key: 'plc', label: 'PLC', group: 'salaried' },
  { key: 'contract', label: 'Contract', group: 'salaried' },
  { key: 'self_employed', label: 'Self-Employed', group: 'self_employed' },
  { key: 'commission_earner', label: 'Commission Earner', group: 'commission' },
  { key: 'freelancer', label: 'Freelancer', group: 'commission' },
];

export const EMPLOYMENT_STATUSES = [
  'Permanent', 'Contract', 'Probation', 'Self-Employed', 'Retired',
];

export const MALAYSIAN_STATES = [
  'Johor', 'Kedah', 'Kelantan', 'Melaka', 'Negeri Sembilan', 'Pahang',
  'Penang', 'Perak', 'Perlis', 'Sabah', 'Sarawak', 'Selangor', 'Terengganu',
  'Kuala Lumpur', 'Putrajaya', 'Labuan',
];

// Document requirement matrix per employment group
export const DOCUMENT_REQUIREMENTS = {
  salaried: [
    { key: 'ic_front', label: 'IC Front', required: true, maxFiles: 1 },
    { key: 'ic_back', label: 'IC Back', required: true, maxFiles: 1 },
    { key: 'payslip', label: 'Latest 3 Months Payslip', required: true, maxFiles: 3 },
    { key: 'epf', label: 'Latest 2 Years EPF Statement', required: false, maxFiles: 2 },
    { key: 'bank_statement_3m', label: '3 Months Bank Statement', required: false, maxFiles: 3 },
  ],
  self_employed: [
    { key: 'ic_front', label: 'IC Front', required: true, maxFiles: 1 },
    { key: 'ic_back', label: 'IC Back', required: true, maxFiles: 1 },
    { key: 'income_tax_2y', label: 'Latest 2 Years Income Tax Statement', required: false, maxFiles: 2, oneOfGroup: 'self_employed_proof' },
    { key: 'bank_statement_6m', label: 'Latest 6 Months Bank Statement', required: false, maxFiles: 6, oneOfGroup: 'self_employed_proof' },
  ],
  commission: [
    { key: 'ic_front', label: 'IC Front', required: true, maxFiles: 1 },
    { key: 'ic_back', label: 'IC Back', required: true, maxFiles: 1 },
    { key: 'income_statement_6m', label: 'Latest 6 Months Income Statement', required: true, maxFiles: 6 },
    { key: 'bank_statement_6m', label: 'Latest 6 Months Bank Statement', required: false, maxFiles: 6 },
  ],
};
